function forEachData(list = [], cb, parent, childField) {
    list.forEach(item => {
        cb && cb(item, parent)
        if(item[childField]) {
            forEachData(item[childField], cb, item, childField)
        }
    })
}

/**
 *
 *
 * @export
 * @param {*} [list=[]] 树数据
 * @function Callback cb 每项遍历回调；
 * @param {string} [childField='children']  子节点字段;默认`children`
 * @return {Array} list
 */
export default function forEachTree(list = [], cb, childField = 'children') {
    list = JSON.parse(JSON.stringify(list))
    forEachData(list, cb, undefined, childField)
    return list
}
